import type { FormatPeriodLabelParams } from '../types';

const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
] as const;

const formatPeriodLabel = ({ month }: FormatPeriodLabelParams): string => {
    const [yearText, monthText] = month.split('-');
    const monthIndex = Number(monthText) - 1;
    return `${MONTH_NAMES[monthIndex]} ${yearText}`;
};

export default formatPeriodLabel;
